import React, { useEffect, useRef } from 'react';
import { LinearProgress } from '@material-ui/core';
import widgetRender from './bei-light';

function test2(data, action) {
  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'barchart', // barchart, pie, linechart
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 100, right: 50, bottom: 90, left: 50 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 420, height: 330 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      dimensionFields: ['date', 'opinion'],
      dimensionFieldsDatatype: ['date', 'text'],
      dimensionFieldsLabel: ['date', 'opinion'],
      dimensionFieldsFormat: ['%d/%m/%y'],
      dimensionFieldsCustomSort: [null],
      dimensionFieldsSortOrder: ['asc'],
      multiDimensionStyle: 'stacked', // grouped, stacked, diverging, bullet (for bullet & diverging multiDimensionStyle , 2nd axis must have 2 values max !!!)
      calculationFields: ['count'],
      calculationFieldsLabel: ['count'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.2'],
      calculationFieldsAdjustPct: false,
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['serieIndex'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: null,
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: ['#002380', '#5683C5', '#9EB8DE', '#E6EDF6'],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      XYChart: {
        includeOrigin: true, // used for barchart / linechart
        linearGridline: true,
        categoricalGridline: false,
        linearAxis: true,
        linearAxisLine: false,
        linearAxisLabel: true,
        linearAxisLabelFormat: '.0%',
        linearAxisTick: false,
        linearAxisMinMaxExtendFactor: [1, 1],
        linearAxisTicksNumber: 3,
        categoricalAxis: true,
        categoricalAxisLabel: true,
        categoricalAxisTick: false,
        categoricalAxisLabelFormat: '%b %e',
        categoricalAxisLabelVPadding: 10,
        categoricalAxisLabelTextWrapWidth: 38,
        categoricalAxisLabelTextWrapLineHeight: 1.2,
        categoricalAxisLabelTextAnchor: 'middle',
        stackOffset: 'stackOffsetExpand',
        barPadding: 0.4, // value between 0 and 1
        barRadius: 0, // value in px
        barRadiusPosition: 'all', // all, top, bottom
        barGroupPadding: 0.7, // value between 0 and 1
        barBandwithReduction: 0
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 0
      },
      gridline: {
        padding: -10,
        showExtend: true,
        dashArray: '10 10',
        width: 0.5,
        color: '#979797',
        altColor: '#000000',
        opacity: 0.8
      },
      title: {
        visible: true,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '13px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>OPINION</tspan></text>"
      },
      label: {
        visible: false
      },
      tooltip: {
        active: true,
        hPosition: 'shape', // shape, mouse, fixe
        vPosition: 'shape',
        hRelPosition: 'center',
        vRelPosition: 'up',
        // 'column' : ['cout','etp_contractuel','etp_ecart'],
        // 'columnSuffix' : [' ETP absence',' ETP contractuel',' ETP par rapport au indirect'],
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='34' y2='80' style='stroke : #002380;stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan style='font-weight:600;font-size : 18px'>[date]</tspan><tspan x='25' y='50'>Opinion : [opinion]</tspan><tspan x='25' y='70'>Value : [count]</tspan></text></g>",
        variableFormat: {
          date: { datatype: 'date', formatIn: '%d/%m/%y', formatOut: '%B %e' },
          feedbackReceived: { datatype: 'number', formatOut: '.1s' },
          feedbackPending: { datatype: 'number', formatOut: '.1s' }
        },
        tooltipSpecificFn: null
      },
      legend: {
        type: 'manual',
        text: null,
        orientation: 'horizontal',
        hPosition: 'centerViz',
        vPosition: 'bottom',
        alignment: 'center',
        fontFamily: 'Montserrat',
        vPadding: 15,
        color: '#535353',
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        textAnchor: 'start',
        blockPadding: 40,
        SVG:
          "<svg><g class='legendBlock'><g class='block'><g class='element'><rect y='0' width='14' height='14' style='fill : #002380' /></g><g class='element'><text><tspan dy='0.7em' alignement-baseline='middle'>Fair</tspan></text></g></g>" +
          "<g class='block'><g class='element'><rect y='0' width='14' height='14' style='fill : #5683C5' /></g><g class='element'><text><tspan dy='0.7em' alignement-baseline='middle'>Overvalued</tspan></text></g></g>" +
          "<g class='block'><g class='element'><rect y='0' width='14' height='14' style='fill : #9EB8DE' /></g><g class='element'><text><tspan dy='0.7em' alignement-baseline='middle'>Undervalued</tspan></text></g></g>" +
          "<g class='block'><g class='element'><rect y='0' width='14' height='14' style='fill : #E6EDF6' /></g><g class='element'><text><tspan dy='0.7em' alignement-baseline='middle'>Cheap</tspan></text></g></g>" +
          '</g></svg>'
      },
      animation: {
        active: true,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'chart2',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  widgetRender(widgetProperties_US342, action);
}

const ChartOpinionOnValuation = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
    }, [loading]); */

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data]);

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="chart2"
        role="img"
        style={{ width: '100%', height: '410px' }}>
        {loading && (
          <h6>
            <LinearProgress />
          </h6>
        )}
        {error && <h4 style={{ color: 'red', fontSize: 14 }}>{error}</h4>}
      </div>
    </>
  );
};

export default ChartOpinionOnValuation;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
